/**
 * chatDraft - Rascunho de mensagem para o campo de digitação do Chat
 *
 * Permite que outras telas (ex.: compartilhamento de proposta) deixem um texto
 * pré-preenchido para uma conversa específica. O ChatArea consome o rascunho
 * ao abrir a conversa e o remove em seguida (consumo único).
 *
 * Usa sessionStorage por ser volátil (não polui o navegador do usuário) e
 * funcionar tanto na página /tenant/chat quanto no ChatConversationModal.
 *
 * CHANGELOG:
 *   RELEASE: 2026-08-12 v1.0.0 - Versão inicial (compartilhamento de proposta).
 */

// Prefixo da chave no sessionStorage
const KEY_PREFIX = 'chat.draft.';

/** Grava o rascunho de uma conversa */
export function setChatDraft(conversationId: string, text: string): void {
  if (!conversationId || !text) return;
  try {
    sessionStorage.setItem(`${KEY_PREFIX}${conversationId}`, text);
  } catch {
    // sessionStorage indisponível (modo privado): ignora silenciosamente
  }
}

/** Lê e remove o rascunho de uma conversa (consumo único) */
export function consumeChatDraft(conversationId: string): string | null {
  if (!conversationId) return null;
  try {
    const key = `${KEY_PREFIX}${conversationId}`;
    const value = sessionStorage.getItem(key);
    if (value) sessionStorage.removeItem(key);
    return value;
  } catch {
    return null;
  }
}
